export const VERSION = "/v0.1";
export const API = {
  GITHUB_REPOSITORIES: `${VERSION}/github/installations/:installationId/repositories`,
  REPO_CONFIG: `${VERSION}/apps/:ownerName/:appName/repo_config`,
  GITHUB_LATEST_PR: `${VERSION}/github/installations/:installationId/repositories/:ownerName/:repositoryName/pull_requests/latest`,
  GITHUB_BILLING_PLANS: `${VERSION}/github/installations/:installationId/billing_plans`,
};
export const githubUrl = {
  development: "https://github.com/marketplace/app-center-int",
  staging: "https://github.com/marketplace/app-center-staging",
  production: "https://github.com/marketplace/app-center",
};
